export default __webpack_public_path__ + "static/media/star-detail.4f974efc.svg";